import { render, staticRenderFns } from "./AddAddressModal.vue?vue&type=template&id=54f4cbcc&"
import script from "./AddAddressModal.vue?vue&type=script&lang=ts&"
export * from "./AddAddressModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports